import { useCallback, useState } from 'react';
import useIsMounted from './use-is-mounted.js';
const COPIED_DURATION = 2000;
/**
 * Custom hook to copy text to the clipboard.
 */
function useCopyToClipboard() {
    const [copied, setCopied] = useState(false);
    const isMounted = useIsMounted();
    const copy = useCallback(async (text) => {
        try {
            await navigator.clipboard.writeText(text);
        }
        catch (error) {
            console.warn('Copy failed', error);
        }
        setCopied(true);
        const timerId = setTimeout(() => {
            if (isMounted()) {
                setCopied(false);
            }
        }, COPIED_DURATION);
        return () => {
            clearTimeout(timerId);
        };
    }, [isMounted]);
    return {
        copy,
        copied,
    };
}
export default useCopyToClipboard;
